<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/company";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Companies",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('companies.singular')) }},
    resourceRoute: {default: 'companies'},
    modelVariable: {default: 'company'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('companies.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('companies.plural')),
          href: "/companies",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/companies/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/companies/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/companies/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/companies/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/companies/${this.$route.params.key}`)
    }
  }
}
</script>
